var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.33398,
    y: 5.33331,
    width: 5.83333,
    height: 5.83333,
    rx: 1.5,
    fill: "#64748B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.834 6.83331C12.834 6.00489 13.5056 5.33331 14.334 5.33331H17.1673C17.9957 5.33331 18.6673 6.00489 18.6673 6.83331V9.66665C18.6673 10.4951 17.9957 11.1666 17.1673 11.1666H14.334C13.5056 11.1666 12.834 10.4951 12.834 9.66665V6.83331ZM5.33398 14.3333C5.33398 13.5049 6.00556 12.8333 6.83398 12.8333H9.66732C10.4957 12.8333 11.1673 13.5049 11.1673 14.3333V17.1666C11.1673 17.9951 10.4957 18.6666 9.66732 18.6666H6.83399C6.00556 18.6666 5.33398 17.9951 5.33398 17.1666V14.3333ZM14.334 12.8333C13.5056 12.8333 12.834 13.5049 12.834 14.3333V17.1666C12.834 17.9951 13.5056 18.6666 14.334 18.6666H17.1673C17.9957 18.6666 18.6673 17.9951 18.6673 17.1666V14.3333C18.6673 13.5049 17.9957 12.8333 17.1673 12.8333H14.334Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.f5d99e69681ac355ff90edfc89e2ee96.svg";
export { ForwardRef as ReactComponent };